import { render } from "./income_log.vue?vue&type=template&id=5f377892&scoped=true"
import script from "./income_log.vue?vue&type=script&lang=js"
export * from "./income_log.vue?vue&type=script&lang=js"

import "./income_log.vue?vue&type=style&index=0&id=5f377892&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\project\\forex\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f377892"]])

export default __exports__